import React from 'react';
import Landing2Layout from './layout/Landing2Layout';
import Hero2 from './sections2/Hero2';
import Features2 from './sections2/Features2';
import HowItWorks2 from './sections2/HowItWorks2';
import VideoTeaser2 from './sections2/VideoTeaser2';
import PortalShowcase2 from './sections2/PortalShowcase2';
import SecurityTeaser2 from './sections2/SecurityTeaser2';
import SocialProof2 from './sections2/SocialProof2';
import PricingTeaser2 from './sections2/PricingTeaser2';
import FAQ2 from './sections2/FAQ2';
import CTA2 from './sections2/CTA2';

/**
 * Home del rediseño (jul-2026). Compone las secciones portadas del diseño
 * (landing/PaySlip.dc.html) con los ajustes de negocio ya aplicados:
 * prueba con tarjeta, sin ISO 27001, México suavizado, sin cifras/testimonios
 * ficticios (SocialProof reformulado, cualitativo).
 */
const Home2 = () => (
  <Landing2Layout>
    <Hero2 />
    <Features2 />
    <HowItWorks2 />
    <VideoTeaser2 />
    <PortalShowcase2 />
    <SecurityTeaser2 />
    <SocialProof2 />
    <PricingTeaser2 />
    <FAQ2 />
    <CTA2 />
  </Landing2Layout>
);

export default Home2;
